<div class="get-link-1">
  <span class="get-link" (click)="openCodeModal(data)">
    <img
      src="../../../../assets/images/Icon-step.svg"
      width="20"
      height="20"
      alt=""
    />
    <span>获取验证码教程</span>
  </span>
</div>
<div class="get-link-2">
  <ng-container *ngIf="timeout === 91 && !link">
    <span class="legacy-get-code-link">
    <img
      src="../../../assets/images/Icon-link.svg"
      alt="link"
      width="20"
      height="20"
    />
    <span (click)="openTipModal(data)"> 点击获取链接 </span>
    </span>
    <span class="legacy-netflix-get-code-link">
    <span class="get-code-link" (click)="getLink(data)">
      验证码：点击获取验证码
    </span>
    </span>
    <span class="get-code-label">验证码：</span>
    <span
      class="chatgpt-get-code-link"
      (click)="getLink(data)"
      style="
        text-decoration: underline;
        color: var(--primary-color);
        cursor: pointer;
      "
      >点击获取验证码
    </span>
  </ng-container>

  <ng-container *ngIf="timeout !== 0 && timeout !== 91 && !link">
    <span class="legacy-querying-code-link">
    <img
      src="../../../assets/images/Icon-link.svg"
      alt="link"
      width="20"
      height="20"
    />
    <span
      style="color: #909090; text-decoration-line: underline; cursor: default"
    >
      查询正在进行中…({{ timeout }})秒
    </span>
    </span>
    <span class="get-code-label">验证码：</span>
    <span
      class="chatgpt-code-querying"
      style="color: #909090; text-decoration-line: underline; cursor: unset"
    >
      查询正在进行中…({{ timeout }})秒
    </span>
  </ng-container>

  <ng-container *ngIf="timeout === 0 && !link">
    <mat-icon>refresh</mat-icon>
    <span class="again" (click)="refresh(data)"> 重试 </span>
  </ng-container>

  <ng-container *ngIf="link">
    <img
      src="../../../assets/images/Icon-link.svg"
      alt="link"
      width="20"
      height="20"
    />
    <span class="link">
      {{ link }}
    </span>
  </ng-container>
</div>
<div class="get-link-3" *ngIf="link">
  <button (click)="openLink()">打开链接查看验证码</button>
</div>
